webpackJsonp([3],{

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(737)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(742),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bcd3cbc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    var goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aa1c8f08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("b86dabf0", content, true, {});

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#download-popup[data-v-aa1c8f08]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;background-color:rgba(0,0,0,.6)}#download-popup .popup-body[data-v-aa1c8f08]{position:relative;width:75%;height:200px;margin:0 auto;margin-top:10rem;background-size:100%}#download-popup .popup-body-head[data-v-aa1c8f08]{display:block;width:140px;margin:0 auto}#download-popup .popup-body-content[data-v-aa1c8f08]{margin-top:-45px;padding-bottom:10px;border-radius:5px;background:#fff}#download-popup .popup-body-close[data-v-aa1c8f08]{position:absolute;top:-.5rem;right:-.5rem;width:2.6rem;height:2.6rem;line-height:1.6rem}#download-popup .popup-body-go[data-v-aa1c8f08]{display:block;width:90%;height:2.6rem;margin:0 auto;margin-top:5px;color:#fff;text-align:center;line-height:2.6rem;border-radius:5px;font-weight:800;background-color:#25c023}#download-popup .popup-body-text[data-v-aa1c8f08]{padding:0 10px;padding-top:50px;margin-bottom:15px;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/downloadPopup.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,+BAAqC,CACtC,AACD,6CACE,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,cAAe,AACf,iBAAkB,AAClB,oBAAsB,CACvB,AACD,kDACE,cAAe,AACf,YAAa,AACb,aAAe,CAChB,AACD,qDACE,iBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,kBAAmB,AACnB,WAAa,AACb,aAAe,AACf,aAAc,AACd,cAAe,AACf,kBAAoB,CACrB,AACD,gDACE,cAAe,AACf,UAAW,AACX,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,kDACE,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadPopup.vue","sourcesContent":["\n#download-popup[data-v-aa1c8f08] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n#download-popup .popup-body[data-v-aa1c8f08] {\n  position: relative;\n  width: 75%;\n  height: 200px;\n  margin: 0 auto;\n  margin-top: 10rem;\n  background-size: 100%;\n}\n#download-popup .popup-body-head[data-v-aa1c8f08] {\n  display: block;\n  width: 140px;\n  margin: 0 auto;\n}\n#download-popup .popup-body-content[data-v-aa1c8f08] {\n  margin-top: -45px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  background: #fff;\n}\n#download-popup .popup-body-close[data-v-aa1c8f08] {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.5rem;\n  width: 2.6rem;\n  height: 2.6rem;\n  line-height: 1.6rem;\n}\n#download-popup .popup-body-go[data-v-aa1c8f08] {\n  display: block;\n  width: 90%;\n  height: 2.6rem;\n  margin: 0 auto;\n  margin-top: 5px;\n  color: #fff;\n  text-align: center;\n  line-height: 2.6rem;\n  border-radius: 5px;\n  font-weight: 800;\n  background-color: #25c023;\n}\n#download-popup .popup-body-text[data-v-aa1c8f08] {\n  padding: 0 10px;\n  padding-top: 50px;\n  margin-bottom: 15px;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            popup_show: false,
            popup_text: 'lihat 200+ data lebih rinci，silakan download app',
            popup_btn: true,
            now_local_date: new Date().toLocaleDateString()
        };
    },
    mounted: function mounted() {
        if (!window.sessionStorage) {
            window.sessionStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        if (!window.localStorage) {
            window.localStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
    },


    methods: {
        handleClose: function handleClose() {
            this.popup_show = false;
        },
        goDownload: function goDownload() {
            sessionStorage.setItem('loop_run', 'true');
            this.popup_show = false;
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                location.href = '/download';
            } else if (browers.iOS) {
                var utilObj = __webpack_require__(499);
                utilObj.jumpUrl();
            }
        }
    }
};

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_show),
      expression: "popup_show"
    }],
    attrs: {
      "id": "download-popup"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticClass: "popup-body-head",
    attrs: {
      "src": __webpack_require__(505),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body-content"
  }, [_c('p', {
    staticClass: "popup-body-text"
  }, [_vm._v(_vm._s(_vm.popup_text))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_btn),
      expression: "popup_btn"
    }],
    staticClass: "popup-body-go",
    on: {
      "click": _vm.goDownload
    }
  }, [_vm._v("Tekan")])]), _vm._v(" "), _c('img', {
    staticClass: "popup-body-close",
    attrs: {
      "src": __webpack_require__(506)
    },
    on: {
      "click": _vm.handleClose
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_icon.c1b2864.png";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/close_icon.9c943d6.png";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(127)('meta');
var isObject = __webpack_require__(57);
var has = __webpack_require__(64);
var setDesc = __webpack_require__(56).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(86)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon.c67c881.png";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(510);


/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(511);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ 511:
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(85);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Stats_nulldata.7615563.png";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ad89eb5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("fbc1c7c2", content, true, {});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".nav[data-v-7ad89eb5]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0;padding:0;height:2.4rem;background:#16b13a;line-height:2.4rem;overflow:hidden}.nav a[data-v-7ad89eb5]{-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;color:#fff;font-size:.75rem;float:left;text-decoration:none!important;position:relative;height:1.4rem;line-height:1.4rem;padding:.5rem 0;overflow:hidden;font-weight:700;-webkit-tap-highlight-color:rgba(0,0,0,0)}.nav a[data-v-7ad89eb5]:last-of-type{-webkit-box-flex:1.3;-ms-flex-positive:1.3;flex-grow:1.3}.selected[data-v-7ad89eb5]{display:inline-block;width:.5rem;height:.4rem;line-height:1.2rem;background:url(" + escape(__webpack_require__(518)) + ") no-repeat;background-size:100% auto;position:absolute;bottom:-.1rem;left:50%;margin-left:-.2rem;z-index:10}.newsSubTit[data-v-7ad89eb5]{height:2.2rem;width:100%;font-size:.68rem;line-height:2.5rem;text-align:center;color:#2d2f32;border-bottom:.01rem solid #eff1f4;background:#fff}.newsSubTit>div[data-v-7ad89eb5]{top:0;overflow-x:scroll;white-space:nowrap;padding:0 .8rem;position:relative}.newsSubTit>div[data-v-7ad89eb5]::-webkit-scrollbar{display:none}.newsSubTit a[data-v-7ad89eb5]{display:inline-block;padding:0 .7rem;position:relative;height:1.1rem;line-height:1.1rem;padding:.3rem .7rem;color:#2d2f32;font-size:.9rem;-webkit-tap-highlight-color:rgba(0,0,0,0)}.subTitSelected[data-v-7ad89eb5]{color:#16b13a!important;border-bottom:.15rem solid #16b13a}.thirdTitwrap[data-v-7ad89eb5]{height:3.2rem;background:#333d46;overflow:hidden;color:#929cad}.thirdTit[data-v-7ad89eb5]{height:1.5rem;width:94%;margin:.8rem auto;line-height:1.5rem;border:1px solid #1d2328;border-radius:.01rem}.thirdTit a[data-v-7ad89eb5]{width:25%;color:#929cad;float:left;text-align:center;border-right:1px solid #1d2328;text-decoration:none;box-sizing:border-box;height:1.5rem;line-height:1.5rem;font-size:.8rem;padding:0}.thirdTitWidth[data-v-7ad89eb5]{width:33.3%!important}.thirdTit>a.thirdTitSelected[data-v-7ad89eb5]{background:#1d2328!important;color:#fff!important}.thirdTit>a[data-v-7ad89eb5]:last-of-type{border-right:none}.topFixedWrap[data-v-7ad89eb5]{width:100%;z-index:100;position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0}.main>.tab-box-fixed[data-v-7ad89eb5]{position:fixed!important;z-index:10;top:0;left:0}.main>.tab-box-testFix[data-v-7ad89eb5]{z-index:10;top:0;left:0}.tab-box-sticky[data-v-7ad89eb5]{position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0;left:0;z-index:10}.pad[data-v-7ad89eb5]{margin:0 3rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/navNew.vue"],"names":[],"mappings":"AACA,sBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,mBAAoB,AACpB,eAAiB,CAClB,AACD,wBACE,oBAAqB,AACjB,cAAe,AACnB,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,WAAY,AACZ,+BAAiC,AACjC,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,AAClB,yCAA8C,CAC/C,AACD,qCACE,qBAAsB,AAClB,sBAAuB,AACnB,aAAe,CACxB,AACD,2BACE,qBAAsB,AACtB,YAAa,AACb,aAAc,AACd,mBAAoB,AACpB,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,cAAgB,AAChB,SAAU,AACV,mBAAqB,AACrB,UAAY,CACb,AACD,6BACE,cAAe,AACf,WAAY,AACZ,iBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,cAAe,AACf,mCAAqC,AACrC,eAAiB,CAClB,AACD,iCACE,MAAO,AACP,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,iBAAmB,CACpB,AACD,oDACE,YAAc,CACf,AACD,+BACE,qBAAsB,AACtB,gBAAiB,AACjB,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,oBAAqB,AACrB,cAAe,AACf,gBAAiB,AACjB,yCAA8C,CAC/C,AACD,iCACE,wBAA0B,AAC1B,kCAAoC,CACrC,AAED,+BACE,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,aAAe,CAChB,AACD,2BACE,cAAe,AACf,UAAW,AACX,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,oBAAuB,CACxB,AACD,6BACE,UAAW,AACX,cAAe,AAEf,WAAY,AACZ,kBAAmB,AACnB,+BAAgC,AAChC,qBAAsB,AACtB,sBAAuB,AACvB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,SAAW,CACZ,AACD,gCACE,qBAAwB,CACzB,AACD,8CACE,6BAA+B,AAC/B,oBAAuB,CACxB,AACD,0CACE,iBAAmB,CACpB,AAED,+BACE,WAAY,AACZ,YAAa,AACb,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,KAAU,CACX,AACD,sCACE,yBAA2B,AAC3B,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,wCACE,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,iCACE,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,sBACE,aAAe,CAChB","file":"navNew.vue","sourcesContent":["\n.nav[data-v-7ad89eb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 0;\n  padding: 0;\n  height: 2.4rem;\n  background: #16b13a;\n  line-height: 2.4rem;\n  overflow: hidden;\n}\n.nav a[data-v-7ad89eb5] {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  text-align: center;\n  color: #fff;\n  font-size: .75rem;\n  float: left;\n  text-decoration: none !important;\n  position: relative;\n  height: 1.4rem;\n  line-height: 1.4rem;\n  padding: .5rem 0;\n  overflow: hidden;\n  font-weight: bold;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.nav a[data-v-7ad89eb5]:last-of-type {\n  -webkit-box-flex: 1.3;\n      -ms-flex-positive: 1.3;\n          flex-grow: 1.3;\n}\n.selected[data-v-7ad89eb5] {\n  display: inline-block;\n  width: .5rem;\n  height: .4rem;\n  line-height: 1.2rem;\n  background: url(\"../assets/home/home_arrow.png\") no-repeat;\n  background-size: 100% auto;\n  position: absolute;\n  bottom: -0.1rem;\n  left: 50%;\n  margin-left: -0.2rem;\n  z-index: 10;\n}\n.newsSubTit[data-v-7ad89eb5] {\n  height: 2.2rem;\n  width: 100%;\n  font-size: 0.68rem;\n  line-height: 2.5rem;\n  text-align: center;\n  color: #2d2f32;\n  border-bottom: 0.01rem solid #eff1f4;\n  background: #fff;\n}\n.newsSubTit > div[data-v-7ad89eb5] {\n  top: 0;\n  overflow-x: scroll;\n  white-space: nowrap;\n  padding: 0 .8rem;\n  position: relative;\n}\n.newsSubTit > div[data-v-7ad89eb5]::-webkit-scrollbar {\n  display: none;\n}\n.newsSubTit a[data-v-7ad89eb5] {\n  display: inline-block;\n  padding: 0 .7rem;\n  position: relative;\n  height: 1.1rem;\n  line-height: 1.1rem;\n  padding: .3rem .7rem;\n  color: #2d2f32;\n  font-size: .9rem;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.subTitSelected[data-v-7ad89eb5] {\n  color: #16b13a !important;\n  border-bottom: .15rem solid #16b13a;\n}\n/*stat 三级导航*/\n.thirdTitwrap[data-v-7ad89eb5] {\n  height: 3.2rem;\n  background: #333d46;\n  overflow: hidden;\n  color: #929cad;\n}\n.thirdTit[data-v-7ad89eb5] {\n  height: 1.5rem;\n  width: 94%;\n  margin: .8rem auto;\n  line-height: 1.5rem;\n  border: 1px solid #1d2328;\n  border-radius: 0.01rem;\n}\n.thirdTit a[data-v-7ad89eb5] {\n  width: 25%;\n  color: #929cad;\n  /*display: inline-block;*/\n  float: left;\n  text-align: center;\n  border-right: 1px solid #1d2328;\n  text-decoration: none;\n  box-sizing: border-box;\n  height: 1.5rem;\n  line-height: 1.5rem;\n  font-size: .8rem;\n  padding: 0;\n}\n.thirdTitWidth[data-v-7ad89eb5] {\n  width: 33.3% !important;\n}\n.thirdTit > a.thirdTitSelected[data-v-7ad89eb5] {\n  background: #1d2328 !important;\n  color: #fff !important;\n}\n.thirdTit > a[data-v-7ad89eb5]:last-of-type {\n  border-right: none;\n}\n/*定位*/\n.topFixedWrap[data-v-7ad89eb5] {\n  width: 100%;\n  z-index: 100;\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0rem;\n}\n.main > .tab-box-fixed[data-v-7ad89eb5] {\n  position: fixed !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.main > .tab-box-testFix[data-v-7ad89eb5] {\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.tab-box-sticky[data-v-7ad89eb5] {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.pad[data-v-7ad89eb5] {\n  margin: 0 3rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_arrow.09476cf.png";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(125);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(187);

var _AppToolbar = __webpack_require__(520);

var _AppToolbar2 = _interopRequireDefault(_AppToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'navVue',
    components: {
        AppToolbar: _AppToolbar2.default
    },

    props: ['subtitleData', 'navSelected', 'isThirdTit', 'pad', 'loadingShowProp'],

    data: function data() {
        return {
            thirdTotalTitle: [],
            navMap: {
                'BERITA': '/news',
                'COCOK': '/matchs',
                'VIDEO': '/video',
                'STATISTIK': '/stats'
            },
            currentListData: [],
            loading: false,
            subNavTranslateX: function subNavTranslateX() {},
            googlePlayUrl: 'intent://open/#Intent;scheme=allfootball;package=com.allfootball.news;end'
        };
    },


    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getSubtitChoose', 'getThirdTitChoose']), {
        statsSubTabList: function statsSubTabList() {
            return this.$store.state.navStore.statsSubTabList;
        }
    }),

    created: function created() {
        if (this.navSelected !== 'STATISTIK') return;

        var statsSubTabList = this.statsSubTabList;
        var getSubtitChoose = this.getSubtitChoose;

        if (statsSubTabList.length) {
            var selectedSubtab = statsSubTabList.find(function (sub) {
                return sub.label === getSubtitChoose;
            });

            if (selectedSubtab) {
                this.thirdTotalTitle = selectedSubtab.urlApi;
            } else if (!getSubtitChoose) {
                this.thirdTotalTitle = statsSubTabList[0].urlApi;
            }
        }

        this.$store.commit('setThirdTitChoose', this.thirdTotalTitle.length && this.thirdTotalTitle[0].title || 'Tabel');
    },
    mounted: function mounted() {
        this.subNavTranslateX = function (index) {
            var scrollBar = document.getElementById('scroll');
            var scrollBarTab = scrollBar.querySelectorAll('a');
            var screenWidth = document.documentElement.clientWidth;
            this.scrollLeft = scrollBar.scrollLeft;

            this.leftToScreen = scrollBarTab[index].getBoundingClientRect().left;

            this.rightToScreen = screenWidth - (this.leftToScreen + scrollBarTab[index].getBoundingClientRect().width);

            var average = (this.leftToScreen + this.rightToScreen) / 2;

            if (this.leftToScreen < this.rightToScreen) {
                scrollBar.scrollLeft -= average - this.leftToScreen;
            } else {
                scrollBar.scrollLeft += average - this.rightToScreen;
            }
        };
    },


    methods: {
        subTitToggle: function subTitToggle(item, index) {
            if (this.loadingShowProp) return;
            if (this.getSubtitChoose === item.label) return;

            var subTitle = this.getUrlTitle(item.label);

            if (this.$route.params.subtitle) {
                history.replaceState(null, null, './' + subTitle);
            } else {
                history.replaceState(null, null, this.$route.path + '/' + subTitle);
            }

            this.subNavTranslateX(index);
            this.scrollFn(item.label);

            if (!this.isThirdTit) {
                this.subNavTranslateX(index);
                this.scrollFn(item.label);

                this.$store.commit('setSubtitChoose', item.label);

                var urlApi = item.urlApi;

                if (this.navSelected === 'BERITA') {
                    this.$store.dispatch('newsListApi', { urlApi: urlApi });
                } else if (this.navSelected === 'COCOK') {
                    this.$store.dispatch('matchListApi', { urlApi: urlApi });
                } else if (this.navSelected === 'VIDEO') {
                    this.$store.dispatch('videoListApi', { urlApi: urlApi, type: 1 });
                }
            } else {
                if (this.navSelected === 'STATISTIK') {
                    var _urlApi = item.urlApi && item.urlApi[0].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '') || '';

                    if (this.statsSubTabList.length && item.label) {
                        var res = this.statsSubTabList.find(function (elem) {
                            return elem.label === item.label;
                        });
                        this.thirdTotalTitle = res.urlApi ? res.urlApi : this.thirdTotalTitle;
                    }

                    this.$store.commit('setSubtitChoose', item.label);
                    this.$store.commit('setThirdTitChoose', 'Tabel');
                    this.$store.dispatch('statsListApi', { urlApi: _urlApi, thirdTitChoose: 'Tabel' });
                }
            }
        },
        thirdTitleToggle: function thirdTitleToggle(elem) {
            if (this.loadingShowProp) return;
            if (this.getThirdTitChoose === elem.title) return;

            this.$store.commit('setThirdTitChoose', elem.title);
            this.scrollFn(this.getSubtitChoose);

            if (this.navSelected === 'STATISTIK') {
                var urlApi = elem.url && elem.url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '') || '';
                this.$store.dispatch('statsListApi', { urlApi: urlApi, thirdTitChoose: elem.title });
            }
        },
        scrollFn: function scrollFn() {
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);

            var headHeight = 0;
            var topFixedWrap = document.getElementById('topFixedWrap');
            var contentWrap = document.getElementById('contentWrap');

            if (document.body.scrollTop || document.documentElement.scrollTop >= headHeight) {
                if (browers.Android) {
                    topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                    setTimeout(function () {
                        topFixedWrap.className = 'topFixedWrap';
                    }, 10);
                    contentWrap.style.paddingTop = 0 + 'px';
                    console.log(contentWrap.style.paddingTop);
                } else if (browers.iOS) {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }

                setTimeout(function () {
                    console.log('**滚了 ', headHeight);
                    document.body.scrollTop = headHeight;
                    document.documentElement.scrollTop = headHeight;
                }, 10);
                console.log('document.body.scrollTop:' + document.body.scrollTop);
            } else {
                if (browers.Android) {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }
            }
        }
    }
};

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(525),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e27a4f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(522);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("61f54a8f", content, true, {});

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:D-DINExp-Bold;src:url(" + escape(__webpack_require__(523)) + ")}[data-v-6e27a4f2]{box-sizing:border-box}.app-toolbar[data-v-6e27a4f2]{display:inline-block;height:100%;margin:0 .375rem 0 auto;padding-left:.2rem;-webkit-transform:none;transform:none}.app-toolbar .btn-group[data-v-6e27a4f2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:-webkit-max-content;width:-moz-max-content;width:max-content;height:100%}.app-toolbar .btn-group .add-to-home-btn[data-v-6e27a4f2],.app-toolbar .btn-group .download-btn[data-v-6e27a4f2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:1.1875rem;padding:0 .1875rem;font-size:.8rem;font-weight:500;border-radius:.1875rem;border:1px solid #fff;-webkit-tap-highlight-color:transparent;outline:none}.app-toolbar .btn-group .download-btn[data-v-6e27a4f2]{min-width:3.25rem;background:#fff;color:#16b13a;font-family:SF UI Display}.app-toolbar .btn-group .download-btn .icon-logo[data-v-6e27a4f2]{width:1rem;height:.625rem;margin-right:.125rem}.app-toolbar .btn-group .add-to-home-btn[data-v-6e27a4f2]{margin-left:.1875rem;min-width:1.8125rem;color:#fff;background-color:#16b13a}.guide-modal[data-v-6e27a4f2]{z-index:10001;position:fixed;top:0;left:0;right:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:11.625rem 2.875rem 1.875rem}.guide-modal .step[data-v-6e27a4f2],.guide-modal[data-v-6e27a4f2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.guide-modal .step[data-v-6e27a4f2]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;position:relative;width:17.6875rem;font-weight:500;font-size:1.0625rem;color:#fff}.guide-modal .step[data-v-6e27a4f2]:before{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;content:attr(data-index);margin-right:.5625rem;width:1.0625rem;height:1.0625rem;font-size:.8125rem;color:#000;border-radius:50%;background:#fff;font-family:D-DINExp-Bold}.guide-modal .step .icon-step[data-v-6e27a4f2]{width:1.125rem;height:1.125rem;margin:0 .3125rem}.guide-modal .img-lite[data-v-6e27a4f2]{width:16.125rem;height:3.6875rem;margin:.6rem 0 2rem 1.5rem}.guide-modal .btn-add[data-v-6e27a4f2]{width:14.3125rem;height:2.375rem;line-height:2.375rem;text-align:center;font-size:.9375rem;font-weight:500;color:#16b13a;border-radius:1.1875rem;border:1px solid #16b13a}.mask[data-v-6e27a4f2]{z-index:9999;position:fixed;top:0;left:0;right:0;bottom:0;background-color:#000;opacity:.8}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/AppToolbar.vue"],"names":[],"mappings":"AACA,WACE,0BAA6B,AAC7B,iCAA4C,CAC7C,AACD,kBACE,qBAAuB,CACxB,AACD,8BACE,qBAAsB,AACtB,YAAa,AACb,wBAA0B,AAC1B,mBAAoB,AACpB,uBAAwB,AAChB,cAAgB,CACzB,AACD,yCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,WAAa,CACd,AACD,iHAEE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,mBAAqB,AACrB,gBAAkB,AAClB,gBAAiB,AACjB,uBAAyB,AACzB,sBAA0B,AAC1B,wCAAyC,AACzC,YAAc,CACf,AACD,uDACE,kBAAmB,AACnB,gBAAoB,AACpB,cAAe,AACf,yBAA2B,CAC5B,AACD,kEACE,WAAY,AACZ,eAAiB,AACjB,oBAAuB,CACxB,AACD,0DACE,qBAAuB,AACvB,oBAAqB,AACrB,WAAe,AACf,wBAA0B,CAC3B,AACD,8BACE,cAAe,AACf,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AAIT,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAI/B,mCAAqC,CACtC,AACD,kEAZE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAKd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAkB7B,AAfD,oCAOE,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,kBAAmB,AACnB,iBAAkB,AAClB,gBAAiB,AACjB,oBAAqB,AACrB,UAAe,CAChB,AACD,2CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AAC1B,sBAAwB,AACxB,gBAAiB,AACjB,iBAAkB,AAClB,mBAAqB,AACrB,WAAe,AACf,kBAAmB,AACnB,gBAAoB,AACpB,yBAA2B,CAC5B,AACD,+CACE,eAAgB,AAChB,gBAAiB,AACjB,iBAAoB,CACrB,AACD,wCACE,gBAAiB,AACjB,iBAAkB,AAClB,0BAA6B,CAC9B,AACD,uCACE,iBAAkB,AAClB,gBAAiB,AACjB,qBAAsB,AACtB,kBAAmB,AACnB,mBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,wBAAyB,AACzB,wBAA0B,CAC3B,AACD,uBACE,aAAc,AACd,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,sBAA0B,AAC1B,UAAa,CACd","file":"AppToolbar.vue","sourcesContent":["\n@font-face {\n  font-family: \"D-DINExp-Bold\";\n  src: url(\"../assets/ttf/D-DINExp-Bold.ttf\");\n}\n*[data-v-6e27a4f2] {\n  box-sizing: border-box;\n}\n.app-toolbar[data-v-6e27a4f2] {\n  display: inline-block;\n  height: 100%;\n  margin: 0 0.375rem 0 auto;\n  padding-left: .2rem;\n  -webkit-transform: none;\n          transform: none;\n}\n.app-toolbar .btn-group[data-v-6e27a4f2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  height: 100%;\n}\n.app-toolbar .btn-group .download-btn[data-v-6e27a4f2],\n.app-toolbar .btn-group .add-to-home-btn[data-v-6e27a4f2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 1.1875rem;\n  padding: 0 0.1875rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  border-radius: 0.1875rem;\n  border: 1px solid #FFFFFF;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n}\n.app-toolbar .btn-group .download-btn[data-v-6e27a4f2] {\n  min-width: 3.25rem;\n  background: #FFFFFF;\n  color: #16B13A;\n  font-family: SF UI Display;\n}\n.app-toolbar .btn-group .download-btn .icon-logo[data-v-6e27a4f2] {\n  width: 1rem;\n  height: 0.625rem;\n  margin-right: 0.125rem;\n}\n.app-toolbar .btn-group .add-to-home-btn[data-v-6e27a4f2] {\n  margin-left: 0.1875rem;\n  min-width: 1.8125rem;\n  color: #FFFFFF;\n  background-color: #16B13A;\n}\n.guide-modal[data-v-6e27a4f2] {\n  z-index: 10001;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 11.625rem 2.875rem 1.875rem;\n}\n.guide-modal .step[data-v-6e27a4f2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  position: relative;\n  width: 17.6875rem;\n  font-weight: 500;\n  font-size: 1.0625rem;\n  color: #FFFFFF;\n}\n.guide-modal .step[data-v-6e27a4f2]::before {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  content: attr(data-index);\n  margin-right: 0.5625rem;\n  width: 1.0625rem;\n  height: 1.0625rem;\n  font-size: 0.8125rem;\n  color: #000000;\n  border-radius: 50%;\n  background: #FFFFFF;\n  font-family: D-DINExp-Bold;\n}\n.guide-modal .step .icon-step[data-v-6e27a4f2] {\n  width: 1.125rem;\n  height: 1.125rem;\n  margin: 0 0.3125rem;\n}\n.guide-modal .img-lite[data-v-6e27a4f2] {\n  width: 16.125rem;\n  height: 3.6875rem;\n  margin: 0.6rem 0 2rem 1.5rem;\n}\n.guide-modal .btn-add[data-v-6e27a4f2] {\n  width: 14.3125rem;\n  height: 2.375rem;\n  line-height: 2.375rem;\n  text-align: center;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  color: #16B13A;\n  border-radius: 1.1875rem;\n  border: 1px solid #16B13A;\n}\n.mask[data-v-6e27a4f2] {\n  z-index: 9999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #000000;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/D-DINExp-Bold.fa367cc.ttf";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            showAddToHomeGuide: false,
            downloadLink: 'https://app.adjust.com/1e8lce5e_1exw643e'
        };
    },


    methods: {
        downloadApp: function downloadApp() {
            window.location.href = this.downloadLink;
        },
        handleClose: function handleClose() {
            this.showAddToHomeGuide = false;
        }
    }
};

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-toolbar",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "download-btn",
    on: {
      "click": _vm.downloadApp
    }
  }, [_c('img', {
    staticClass: "icon-logo",
    attrs: {
      "src": __webpack_require__(526)
    }
  }), _vm._v("\n            Unduh\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "add-to-home-btn",
    on: {
      "click": function($event) {
        _vm.showAddToHomeGuide = true
      }
    }
  }, [_vm._v("Layar Utama")])]), _vm._v(" "), (_vm.showAddToHomeGuide) ? [_c('div', {
    staticClass: "guide-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClose($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "step",
    attrs: {
      "data-index": "3"
    }
  }, [_vm._v("Tambahkan setelah penamaan")]), _vm._v(" "), _c('img', {
    staticClass: "img-lite",
    attrs: {
      "src": __webpack_require__(527),
      "alt": "All Sepakbola - Lite"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-add"
  }, [_vm._v("Dipahami")])]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleClose($event)
      }
    }
  })] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step",
    attrs: {
      "data-index": "1"
    }
  }, [_vm._v("\n                Klik\n                "), _c('img', {
    staticClass: "icon-step",
    attrs: {
      "src": __webpack_require__(528)
    }
  }), _vm._v("\n                Tombol\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step",
    attrs: {
      "data-index": "2"
    }
  }, [_vm._v("\n                Klik\n                "), _c('img', {
    staticClass: "icon-step",
    attrs: {
      "src": __webpack_require__(529)
    }
  }), _vm._v("\n                Tambah ke Layar Utama\n            ")])
}]}

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-download.94c03d1.png";

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guide_3.e6fcd2d.png";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guide_1.f57e82a.png";

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guide_2.5c07388.png";

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixedWrap"
    }
  }, [_c('nav', {
    staticClass: "nav"
  }, [_vm._l((_vm.navMap), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": item
      }
    }, [(_vm.navSelected == index) ? _c('span', {
      staticClass: "selected"
    }) : _vm._e(), _vm._v(_vm._s(index) + "\n        ")])
  }), _vm._v(" "), _c('AppToolbar')], 2), _vm._v(" "), _c('nav', {
    staticClass: "newsSubTit"
  }, [_c('div', {
    staticClass: "newTit",
    attrs: {
      "id": "scroll"
    }
  }, _vm._l((_vm.subtitleData), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'subTitSelected': _vm.getSubtitChoose == item.label, 'pad': _vm.pad
      },
      attrs: {
        "href": ("/" + (_vm.getUrlTitle(_vm.navMap[_vm.navSelected])) + "/" + (_vm.getUrlTitle(item.label)))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.subTitToggle(item, index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n           ")])
  }))]), _vm._v(" "), (_vm.isThirdTit) ? _c('nav', {
    staticClass: "nav thirdTitwrap"
  }, [_c('div', {
    staticClass: "thirdTit"
  }, _vm._l((_vm.thirdTotalTitle), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'thirdTitSelected': _vm.getThirdTitChoose === item.title, 'thirdTitWidth': _vm.thirdTotalTitle.length < 4
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.thirdTitleToggle(item, index)
        }
      }
    }, [_vm._v("\n               " + _vm._s(item.title) + "\n            ")])
  }))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e3a9b23",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("32ea5587", content, true, {});

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".noDataWrap[data-v-4e3a9b23]{width:100%;margin:0 auto 13.33333333rem;padding:4.4rem 0 3rem}.noDataWrap img[data-v-4e3a9b23]{width:9.4rem;display:block;margin:0 auto;height:auto}.sorry[data-v-4e3a9b23]{font-size:.9rem;color:#929cad;text-align:center}.grayColor[data-v-4e3a9b23]{color:#b5bcc4!important}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/nodata.vue"],"names":[],"mappings":"AACA,6BACE,WAAY,AACZ,6BAA8B,AAC9B,qBAAuB,CACxB,AACD,iCACE,aAAc,AACd,cAAe,AACf,cAAe,AACf,WAAa,CACd,AACD,wBACE,gBAAiB,AACjB,cAAe,AACf,iBAAmB,CACpB,AACD,4BACE,uBAA0B,CAC3B","file":"nodata.vue","sourcesContent":["\n.noDataWrap[data-v-4e3a9b23] {\n  width: 100%;\n  margin: 0 auto 13.33333333rem;\n  padding: 4.4rem 0 3rem;\n}\n.noDataWrap img[data-v-4e3a9b23] {\n  width: 9.4rem;\n  display: block;\n  margin: 0 auto;\n  height: auto;\n}\n.sorry[data-v-4e3a9b23] {\n  font-size: .9rem;\n  color: #929cad;\n  text-align: center;\n}\n.grayColor[data-v-4e3a9b23] {\n  color: #b5bcc4 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'loading',
    data: function data() {
        return {};
    },
    props: ['whiteMode']

};

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noDataWrap"
  }, [(_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": __webpack_require__(536)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": __webpack_require__(513)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "sorry",
    class: {
      'grayColor': _vm.whiteMode
    }
  }, [_vm._v("Maaf, belum ada konten")])])
},staticRenderFns: []}

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/emptyData.d277f30.png";

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c51ace98",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("5c22b4a3", content, true, {});

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".loadwrap[data-v-c51ace98]{bottom:0;left:0;width:100%;height:2rem;color:#8c9399;background:#eff1f4;text-align:center;margin:0!important;line-height:2rem;font-size:.8rem}.loadingicon[data-v-c51ace98]{width:1rem;height:1rem;background:url(" + escape(__webpack_require__(508)) + ") no-repeat;background-size:100% 100%;position:absolute;top:.5rem;left:.2rem;animation:rotate-data-v-c51ace98 linear 1.2s both infinite;-webkit-animation:rotate-data-v-c51ace98 linear 1.2s both infinite}.loadingiconStats[data-v-c51ace98]{background:url(" + escape(__webpack_require__(542)) + ") no-repeat;background-size:100% 100%}.loading[data-v-c51ace98]{width:10rem;margin:0 auto;height:2rem;line-height:2rem;position:relative}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-data-v-c51ace98{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loadingtext[data-v-c51ace98]{text-indent:1rem;display:inline-block;font-size:.8rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/loading.vue"],"names":[],"mappings":"AACA,2BACE,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,mBAAqB,AACrB,iBAAkB,AAClB,eAAkB,CACnB,AACD,8BACE,WAAY,AACZ,YAAa,AACb,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,UAAW,AACX,WAAa,AACb,2DAA4D,AAC5D,kEAAoE,CACrE,AACD,mCACE,mDAAkE,AAClE,yBAA2B,CAC5B,AACD,0BACE,YAAa,AACb,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AAeD,kCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AACD,8BACE,iBAAkB,AAClB,qBAAsB,AACtB,eAAkB,CACnB","file":"loading.vue","sourcesContent":["\n.loadwrap[data-v-c51ace98] {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2rem;\n  color: #8c9399;\n  background: #eff1f4;\n  text-align: center;\n  margin: 0 !important;\n  line-height: 2rem;\n  font-size: 0.8rem;\n}\n.loadingicon[data-v-c51ace98] {\n  width: 1rem;\n  height: 1rem;\n  background: url(../assets/home/loading-icon.png) no-repeat;\n  background-size: 100% 100%;\n  position: absolute;\n  top: .5rem;\n  left: 0.2rem;\n  animation: rotate-data-v-c51ace98 linear 1.2s both infinite;\n  -webkit-animation: rotate-data-v-c51ace98 linear 1.2s both infinite;\n}\n.loadingiconStats[data-v-c51ace98] {\n  background: url(../assets/stats/loading-icon-stats.png) no-repeat;\n  background-size: 100% 100%;\n}\n.loading[data-v-c51ace98] {\n  width: 10rem;\n  margin: 0 auto;\n  height: 2rem;\n  line-height: 2rem;\n  position: relative;\n}\n@-webkit-keyframes rotate {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-c51ace98 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-c51ace98 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n.loadingtext[data-v-c51ace98] {\n  text-indent: 1rem;\n  display: inline-block;\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon-stats.f719861.png";

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'loading',
    data: function data() {
        return {};
    },
    props: ['statsLoading']
};

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadwrap"
  }, [_c('p', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "loadingicon",
    class: {
      'loadingiconStats': _vm.statsLoading
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "loadingtext",
    attrs: {
      "id": "loadingWord"
    }
  }, [_vm._v("memuat lebih banyak")])])])
},staticRenderFns: []}

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(66);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(548), __esModule: true };

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191);
__webpack_require__(128);
__webpack_require__(193);
__webpack_require__(549);
__webpack_require__(555);
__webpack_require__(558);
__webpack_require__(560);
module.exports = __webpack_require__(32).Map;


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(550);
var validate = __webpack_require__(514);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(551)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(56).f;
var create = __webpack_require__(192);
var redefineAll = __webpack_require__(189);
var ctx = __webpack_require__(59);
var anInstance = __webpack_require__(188);
var forOf = __webpack_require__(186);
var $iterDefine = __webpack_require__(129);
var step = __webpack_require__(194);
var setSpecies = __webpack_require__(195);
var DESCRIPTORS = __webpack_require__(58);
var fastKey = __webpack_require__(507).fastKey;
var validate = __webpack_require__(514);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var $export = __webpack_require__(50);
var meta = __webpack_require__(507);
var fails = __webpack_require__(86);
var hide = __webpack_require__(51);
var redefineAll = __webpack_require__(189);
var forOf = __webpack_require__(186);
var anInstance = __webpack_require__(188);
var isObject = __webpack_require__(57);
var setToStringTag = __webpack_require__(89);
var dP = __webpack_require__(56).f;
var each = __webpack_require__(552)(0);
var DESCRIPTORS = __webpack_require__(58);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(59);
var IObject = __webpack_require__(130);
var toObject = __webpack_require__(88);
var toLength = __webpack_require__(90);
var asc = __webpack_require__(553);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(554);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
var isArray = __webpack_require__(545);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(50);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(556)('Map') });


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(131);
var from = __webpack_require__(557);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(186);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(559)('Map');


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(50);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(561)('Map');


/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(50);
var aFunction = __webpack_require__(67);
var ctx = __webpack_require__(59);
var forOf = __webpack_require__(186);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("4fd5ccf3", content, true, {});

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".btn-download,a.btn-download{text-decoration:none!important;display:block;padding:.4rem;margin:1.4rem .7rem 2.5rem;height:1.8rem;line-height:1.8rem;color:#fff;background:#16ac3a;border-radius:.2rem;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/downloadFooter.vue"],"names":[],"mappings":"AACA,6BAEE,+BAAiC,AACjC,cAAe,AACf,cAAe,AACf,2BAAkC,AAClC,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadFooter.vue","sourcesContent":["\n.btn-download,\na.btn-download {\n  text-decoration: none !important;\n  display: block;\n  padding: .4rem;\n  margin: 1.4rem .7rem 2.5rem .7rem;\n  height: 1.8rem;\n  line-height: 1.8rem;\n  color: #fff;\n  background: #16ac3a;\n  border-radius: .2rem;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'downloadFooter',
    data: function data() {
        return {
            isMatch: false,
            isArticle: false
        };
    },
    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(499);

            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'downloadFoot', 'opreamini');
            }

            utilObj.jumpUrl();
        }
    },
    mounted: function mounted() {
        if (window.location.href.indexOf('match') > -1) {
            this.isMatch = true;
        } else {
            this.isArticle = true;
        }
    }
};

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMatch) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/apk/allfootball-368.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v("\n      Unduh Semua Sepakbola untuk pertandingan lainnya\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isArticle) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/apk/allfootball-368.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('downloadForComments')) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAxtJREFUSEu9lk1oHGUYx///d97ZTeghEZLZKDkUPBRFUKzQ7qyB9OBBNFnxEPy4hOgtEUoolVLSpu2lEBD1Iq1oD35AG0kymxoQBQPm4xQMiHgp9GKTZqoSDG2zyc77tO9uvs0msyHxndPsPvP85v98DlHm1Af+TQX5ca518lMQUs5u4++pwH9LIF2JPFr/bJv8Z+sz3M5J/ffNDUpHsxCBWY7O3GuZvLwDzPqQVM7PiuC6qnGTZj56M3xjbDAWzBqlcunXoZ1hKRhA2Bdmx0+XA6Zy6bfF8Av1hFtt5pdOh/nGj9DWH+0MExAXUFLbC1MX+K8poB9AklDdc9mxT9ALteZk3eY7ABqUrrB18sqazXlYj2spKDn+uVnXzy++QsWXANasOLNv9jdEuqGYgsAAvArIvyAVRFZT8A6IJyFYAPgxRRJCaBgQCgsi/MN1FodnWqYe0IJSC8uXRORDJtTmUiAgyzaMgNVLvS5qVV0pzKU7ulv+t68TCcTg23B2sZ1e0JRhUsYkb+IU3J5smFCQvOmkF2RGoPEqCrGqe08wGxUB7tAb8n+Dw+dgDhYGg5BeLjMN4vkDhwnm6AX+r1B8YVeYTbbB8uPmsJeON1NWol5se96NBysa4xYofTTqkFBO0VVPFSs1zqkIBtie+yDMTnxmfXuD/tOieNKp0V1moYBYUYmtDFgC2BFmx7/ZKMQb8NNwcA3EkR3DWqEym6v3wtaJr7ZG7fBgc+19tTRAxRNlFe4XzMLrcsdfdBJ6quxg2E+YF2R6qHFRyg2GimBSLPmOMDvx9aZl+YPvySLPQaFzxyKpCAYUALZvLBAvyLxLmrOo0s/Iw/+srs2prQhWnG0cjXQhK5Fb6xpzDYImOHR3LfviOqikqdceKK2RjWslTk+vw3L+NMj/ZzamgvTvotSzscIRS8Y2RqVxF9rZ+Ascvmw36oEdm3PBHdYNHX/fqdKfH+imTiqYfPQlG2+kq/NVGFHaaZaiupUPjn2SSU3IUnRbufpY6QvpylHXa6jqAaQNYLVAWNrkez8iIIk8ID9pleyZaRn96xEO3naTQLauKwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(596), __esModule: true };

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597);
module.exports = __webpack_require__(32).Object.values;


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(50);
var $values = __webpack_require__(598)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(126);
var toIObject = __webpack_require__(87);
var isEnum = __webpack_require__(190).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-310d2b2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("e1c82d56", content, true, {});

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".match-tag-container[data-v-310d2b2e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin:0 auto;padding:.125rem .25rem;font-weight:500;font-size:.5rem;color:#16b13a;border-radius:2px;border:1px solid #16b13a;background-color:#fff;font-family:SF UI Display}.match-tag-container .icon-play[data-v-310d2b2e]{margin-right:.1875rem;width:.5625rem;height:.5rem}.match-tag-container.living-tag-container[data-v-310d2b2e]{color:#fff;background:#16b13a}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/components/AppMatchTag.vue"],"names":[],"mappings":"AACA,sCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,cAAe,AACf,uBAA0B,AAC1B,gBAAiB,AACjB,gBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,sBAA0B,AAC1B,yBAA2B,CAC5B,AACD,iDACE,sBAAwB,AACxB,eAAiB,AACjB,YAAe,CAChB,AACD,2DACE,WAAe,AACf,kBAAoB,CACrB","file":"AppMatchTag.vue","sourcesContent":["\n.match-tag-container[data-v-310d2b2e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: 0 auto;\n  padding: 0.125rem 0.25rem;\n  font-weight: 500;\n  font-size: 0.5rem;\n  color: #16b13a;\n  border-radius: 2px;\n  border: 1px solid #16b13a;\n  background-color: #ffffff;\n  font-family: SF UI Display;\n}\n.match-tag-container .icon-play[data-v-310d2b2e] {\n  margin-right: 0.1875rem;\n  width: 0.5625rem;\n  height: 0.5rem;\n}\n.match-tag-container.living-tag-container[data-v-310d2b2e] {\n  color: #ffffff;\n  background: #16b13a;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = __webpack_require__(547);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconLive = __webpack_require__(606);
var iconLiving = __webpack_require__(568);

var TAG_TYPES = new _map2.default().set("1", {
    text: "LANGSUNG HD",
    icon: iconLive
}).set("2", {
    text: "HIGHLIGHTS",
    icon: iconLiving
});

exports.default = {
    props: {
        type: {
            type: String,
            default: ""
        }
    },

    computed: {
        activeTag: function activeTag() {
            return TAG_TYPES.get(this.type);
        }
    }
};

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAhdJREFUSEu9lkuojVEYhp9XLsmAkcuZGogUSUkoBgYiykAuE2F2KJ1EEgMm6tSJMxHCwKVEDMiEgWIqSjJRRnIJA0q5nc///q1df7tztrX2Pp2/9mCv//3eZ631ff+3lhjjiYj7wENgWFKMpWuOR8R2YD+wWdLX9hiNZhIRc4H36d1RSac7TEqeTERsAW4C04Ctku5mwSyKiE3AvRQwKOlwB+AO4BIwHbBuSNLfjrCI8Err1UoaiYiNwK002wFJZyNiUsukobkNTPYWSjrf0EQzBbVxRFi4HlgOzExmntkXYACYA4wAF6r/3wADWynYCcwDvgNngKkJ7Pcee+0dqnbmhzfboFPAkYZBTj2UaG4Auw1bBTwtiexS22/YA2BDlwYlYe8MewksLonqUvvJsBfAki4NSsI+GvYcWJoZ9TsVkYuq9PlQAnsDDFa/GcCh6jPoK6Rlw/zNHZB0Ln2X84GDqQ/mMrNhv4A9kq63Nd6VwBVgQQYxG+Zc7ZV0td00ImYBd4B1/wH2Dkvbugx4NlGw41W/PDmeMOfsWlvOZlcN+gTQP545+1M30kaBRMQu4Fh1YC7MAFmSnTOLHwM+jV0QrsA1wJRMUDGswHdUab2yCe2Nr4BFvU47I77u+k+A1RniXiX1ebYPuNirU0b8ZcN8/fJpvTYjoFvJW2BF63blEnYX2Jbufh7PugV3oNvjZ5WiR/aW9PkfcA7mVa4E05cAAAAASUVORK5CYII="

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-tag-container",
    class: {
      'living-tag-container': _vm.type === '1'
    }
  }, [_c('img', {
    staticClass: "icon-play",
    attrs: {
      "src": _vm.activeTag.icon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-text"
  }, [_vm._v(_vm._s(_vm.activeTag.text))])])
},staticRenderFns: []}

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(738);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("e1a921e0", content, true, {});

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(498);
exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".listwrap[data-v-bcd3cbc0]{height:auto;overflow:hidden}.dateTit[data-v-bcd3cbc0]{text-align:center;color:#8c9399;font-size:.8rem;margin:0 auto;height:2rem;line-height:2rem;background:#eff1f4}.list[data-v-bcd3cbc0]{height:5.4rem;overflow:hidden;position:relative;border-bottom:1px solid #eff1f4;background:#fff}.list dl[data-v-bcd3cbc0]{width:6.4rem}.list dl dt[data-v-bcd3cbc0]{width:2.2rem;height:2.2rem;overflow:hidden;text-align:center;margin:0 auto .4rem}.list dl dt img[data-v-bcd3cbc0]{width:100%;display:block}.list dl dd[data-v-bcd3cbc0]{text-align:center;font-size:.68rem;color:#606369;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.flwrap[data-v-bcd3cbc0]{float:left;margin:.9rem 0 .9rem .6rem}.frwrap[data-v-bcd3cbc0]{float:right;margin:.9rem .6rem .9rem 0}.line[data-v-bcd3cbc0]{width:.6rem;height:.12rem;display:inline-block;background:#333d46;position:relative;top:-.4rem;margin:0 1rem}.text-vs[data-v-bcd3cbc0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;color:#606369}.competewrap[data-v-bcd3cbc0],.text-vs[data-v-bcd3cbc0]{position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);text-align:center;font-size:1.2rem}.competewrap[data-v-bcd3cbc0]{box-sizing:border-box;width:10.4rem;margin-top:.58rem}.competename[data-v-bcd3cbc0]{font-size:12px;line-height:14px;color:#8c9399;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.compete-center[data-v-bcd3cbc0]{margin:.43rem 0}.status[data-v-bcd3cbc0]{font-size:12px;line-height:14px;color:#8c9399}.dot[data-v-bcd3cbc0]{color:#16b13a;width:2rem;display:inline-block;position:relative;top:-.04rem;font-size:1rem;font-style:normal}.playingScore[data-v-bcd3cbc0],playingLive[data-v-bcd3cbc0]{color:#16b13a;margin-bottom:.4rem;line-height:1.2rem}.playingUnliveTime[data-v-bcd3cbc0]{color:#16b13a;font-size:.8rem}.statusPlaying_competewrap .competename[data-v-bcd3cbc0]{margin-bottom:.4rem}.video_arrow[data-v-bcd3cbc0]{width:.36rem;height:.5rem;float:left;margin:.3rem .2rem 0 .5rem}.unStart_competewrap[data-v-bcd3cbc0]{color:#606369;font-size:1rem}.statusPlaying_competewrap[data-v-bcd3cbc0]{color:#16b13a}.statusEnd_competewrap[data-v-bcd3cbc0]{color:#2d2f32}.vs[data-v-bcd3cbc0]{line-height:1.2rem;color:#606369;font-size:1.2rem;margin:.59rem 0}.unStartLive[data-v-bcd3cbc0]{color:#16ac3a;font-size:.6rem;width:2.4rem;height:1rem;border:1px solid #16ac3a;display:inline-block;line-height:1rem;border-radius:.01rem;position:relative;left:-.1rem;top:0;-webkit-transform:scale(.7);transform:scale(.7)}.text-gray[data-v-bcd3cbc0],.unStartTime[data-v-bcd3cbc0]{color:#8c9399;font-size:.68rem;line-height:12px}.loadwrap[data-v-bcd3cbc0]{bottom:0;left:0;width:100%;height:2rem;color:#8c9399;background:#eff1f4;text-align:center;margin:0!important;line-height:2rem;font-size:.68rem}.loadingicon[data-v-bcd3cbc0]{width:1rem;height:1rem;background:url(" + escape(__webpack_require__(508)) + ") no-repeat;background-size:100% 100%;position:absolute;top:.5rem;left:0;animation:rotate-data-v-bcd3cbc0 linear 1.2s both infinite;-webkit-animation:rotate-data-v-bcd3cbc0 linear 1.2s both infinite}.loading[data-v-bcd3cbc0]{width:6rem;margin:0 auto;height:2rem;line-height:2rem;position:relative}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-data-v-bcd3cbc0{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loadingtext[data-v-bcd3cbc0]{text-indent:.4rem;display:inline-block}.contentWrap[data-v-bcd3cbc0]{min-height:38rem}.operamini-tips[data-v-bcd3cbc0]{background:#ff0;text-align:center;font-weight:700}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/pages/AppMatch.vue"],"names":[],"mappings":"AACA,2BACE,YAAa,AACb,eAAiB,CAClB,AACD,0BACE,kBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,kBAAoB,CACrB,AACD,uBACE,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,gCAAiC,AACjC,eAAiB,CAClB,AACD,0BACE,YAAc,CACf,AACD,6BACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,mBAAqB,CACtB,AACD,iCACE,WAAY,AACZ,aAAe,CAChB,AACD,6BACE,kBAAmB,AACnB,iBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,yBACE,WAAY,AACZ,0BAA4B,CAC7B,AACD,yBACE,YAAa,AACb,0BAA4B,CAC7B,AACD,uBACE,YAAa,AACb,cAAe,AACf,qBAAsB,AACtB,mBAAoB,AACpB,kBAAmB,AACnB,WAAa,AACb,aAAe,CAChB,AACD,0BAKE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,YAAa,AAGb,aAAe,CAChB,AACD,wDAfE,kBAAmB,AACnB,SAAU,AACV,mCAAoC,AAC5B,2BAA4B,AAQpC,kBAAmB,AACnB,gBAAkB,CAanB,AAVD,8BACE,sBAAuB,AAEvB,cAAe,AAMf,iBAAmB,CACpB,AACD,8BACE,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,iCACE,eAAiB,CAClB,AACD,yBACE,eAAgB,AAChB,iBAAkB,AAClB,aAAe,CAChB,AACD,sBACE,cAAe,AACf,WAAY,AACZ,qBAAsB,AACtB,kBAAmB,AACnB,YAAc,AACd,eAAgB,AAChB,iBAAmB,CACpB,AACD,4DAEE,cAAe,AACf,oBAAsB,AACtB,kBAAoB,CACrB,AACD,oCACE,cAAe,AACf,eAAkB,CACnB,AACD,yDACE,mBAAsB,CACvB,AACD,8BACE,aAAe,AACf,aAAe,AACf,WAAY,AACZ,0BAA+B,CAChC,AACD,sCACE,cAAe,AACf,cAAgB,CACjB,AACD,4CACE,aAAe,CAChB,AACD,wCACE,aAAe,CAChB,AACD,qBACE,mBAAoB,AACpB,cAAe,AACf,iBAAkB,AAClB,eAAkB,CACnB,AACD,8BACE,cAAe,AACf,gBAAkB,AAClB,aAAc,AACd,YAAa,AACb,yBAA0B,AAC1B,qBAAsB,AACtB,iBAAkB,AAClB,qBAAuB,AACvB,kBAAmB,AACnB,YAAc,AACd,MAAU,AACV,4BAA8B,AACtB,mBAAsB,CAC/B,AACD,0DAEE,cAAe,AACf,iBAAmB,AACnB,gBAAkB,CACnB,AACD,2BACE,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,mBAAqB,AACrB,iBAAkB,AAClB,gBAAmB,CACpB,AACD,8BACE,WAAY,AACZ,YAAa,AACb,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,UAAW,AACX,OAAW,AACX,2DAA4D,AAC5D,kEAAoE,CACrE,AACD,0BACE,WAAY,AACZ,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AAeD,kCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AACD,8BACE,kBAAoB,AACpB,oBAAsB,CACvB,AACD,8BACE,gBAAkB,CACnB,AACD,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB","file":"AppMatch.vue","sourcesContent":["\n.listwrap[data-v-bcd3cbc0] {\n  height: auto;\n  overflow: hidden;\n}\n.dateTit[data-v-bcd3cbc0] {\n  text-align: center;\n  color: #8c9399;\n  font-size: .8rem;\n  margin: 0 auto;\n  height: 2rem;\n  line-height: 2rem;\n  background: #eff1f4;\n}\n.list[data-v-bcd3cbc0] {\n  height: 5.4rem;\n  overflow: hidden;\n  position: relative;\n  border-bottom: 1px solid #eff1f4;\n  background: #fff;\n}\n.list dl[data-v-bcd3cbc0] {\n  width: 6.4rem;\n}\n.list dl dt[data-v-bcd3cbc0] {\n  width: 2.2rem;\n  height: 2.2rem;\n  overflow: hidden;\n  text-align: center;\n  margin: 0 auto .4rem;\n}\n.list dl dt img[data-v-bcd3cbc0] {\n  width: 100%;\n  display: block;\n}\n.list dl dd[data-v-bcd3cbc0] {\n  text-align: center;\n  font-size: 0.68rem;\n  color: #606369;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.flwrap[data-v-bcd3cbc0] {\n  float: left;\n  margin: .9rem 0 .9rem .6rem;\n}\n.frwrap[data-v-bcd3cbc0] {\n  float: right;\n  margin: .9rem .6rem .9rem 0;\n}\n.line[data-v-bcd3cbc0] {\n  width: .6rem;\n  height: .12rem;\n  display: inline-block;\n  background: #333d46;\n  position: relative;\n  top: -0.4rem;\n  margin: 0 1rem;\n}\n.text-vs[data-v-bcd3cbc0] {\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 100%;\n  text-align: center;\n  font-size: 1.2rem;\n  color: #606369;\n}\n.competewrap[data-v-bcd3cbc0] {\n  box-sizing: border-box;\n  font-size: 1.2rem;\n  width: 10.4rem;\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  text-align: center;\n  margin-top: .58rem;\n}\n.competename[data-v-bcd3cbc0] {\n  font-size: 12px;\n  line-height: 14px;\n  color: #8c9399;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.compete-center[data-v-bcd3cbc0] {\n  margin: .43rem 0;\n}\n.status[data-v-bcd3cbc0] {\n  font-size: 12px;\n  line-height: 14px;\n  color: #8c9399;\n}\n.dot[data-v-bcd3cbc0] {\n  color: #16b13a;\n  width: 2rem;\n  display: inline-block;\n  position: relative;\n  top: -0.04rem;\n  font-size: 1rem;\n  font-style: normal;\n}\n.playingScore[data-v-bcd3cbc0],\nplayingLive[data-v-bcd3cbc0] {\n  color: #16b13a;\n  margin-bottom: 0.4rem;\n  line-height: 1.2rem;\n}\n.playingUnliveTime[data-v-bcd3cbc0] {\n  color: #16b13a;\n  font-size: 0.8rem;\n}\n.statusPlaying_competewrap .competename[data-v-bcd3cbc0] {\n  margin-bottom: 0.4rem;\n}\n.video_arrow[data-v-bcd3cbc0] {\n  width: 0.36rem;\n  height: 0.5rem;\n  float: left;\n  margin: 0.3rem 0.2rem 0 0.5rem;\n}\n.unStart_competewrap[data-v-bcd3cbc0] {\n  color: #606369;\n  font-size: 1rem;\n}\n.statusPlaying_competewrap[data-v-bcd3cbc0] {\n  color: #16b13a;\n}\n.statusEnd_competewrap[data-v-bcd3cbc0] {\n  color: #2d2f32;\n}\n.vs[data-v-bcd3cbc0] {\n  line-height: 1.2rem;\n  color: #606369;\n  font-size: 1.2rem;\n  margin: 0.59rem 0;\n}\n.unStartLive[data-v-bcd3cbc0] {\n  color: #16ac3a;\n  font-size: 0.6rem;\n  width: 2.4rem;\n  height: 1rem;\n  border: 1px solid #16ac3a;\n  display: inline-block;\n  line-height: 1rem;\n  border-radius: 0.01rem;\n  position: relative;\n  left: -0.1rem;\n  top: 0rem;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n}\n.unStartTime[data-v-bcd3cbc0],\n.text-gray[data-v-bcd3cbc0] {\n  color: #8c9399;\n  font-size: 0.68rem;\n  line-height: 12px;\n}\n.loadwrap[data-v-bcd3cbc0] {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2rem;\n  color: #8c9399;\n  background: #eff1f4;\n  text-align: center;\n  margin: 0 !important;\n  line-height: 2rem;\n  font-size: 0.68rem;\n}\n.loadingicon[data-v-bcd3cbc0] {\n  width: 1rem;\n  height: 1rem;\n  background: url(../assets/home/loading-icon.png) no-repeat;\n  background-size: 100% 100%;\n  position: absolute;\n  top: .5rem;\n  left: 0rem;\n  animation: rotate-data-v-bcd3cbc0 linear 1.2s both infinite;\n  -webkit-animation: rotate-data-v-bcd3cbc0 linear 1.2s both infinite;\n}\n.loading[data-v-bcd3cbc0] {\n  width: 6rem;\n  margin: 0 auto;\n  height: 2rem;\n  line-height: 2rem;\n  position: relative;\n}\n@-webkit-keyframes rotate {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-bcd3cbc0 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-bcd3cbc0 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n.loadingtext[data-v-bcd3cbc0] {\n  text-indent: 0.4rem;\n  display: inline-block;\n}\n.contentWrap[data-v-bcd3cbc0] {\n  min-height: 38rem;\n}\n.operamini-tips[data-v-bcd3cbc0] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(740);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(509);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(85);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(512);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _values = __webpack_require__(595);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(125);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(187);

var _downloadFooter = __webpack_require__(562);

var _downloadFooter2 = _interopRequireDefault(_downloadFooter);

var _navNew = __webpack_require__(515);

var _navNew2 = _interopRequireDefault(_navNew);

var _loading = __webpack_require__(539);

var _loading2 = _interopRequireDefault(_loading);

var _nodata = __webpack_require__(531);

var _nodata2 = _interopRequireDefault(_nodata);

var _downloadPopup = __webpack_require__(500);

var _downloadPopup2 = _interopRequireDefault(_downloadPopup);

var _AppMatchTag = __webpack_require__(602);

var _AppMatchTag2 = _interopRequireDefault(_AppMatchTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'app',
    components: {
        DownloadFooter: _downloadFooter2.default,
        navVue: _navNew2.default,
        loading: _loading2.default,
        nodata: _nodata2.default,
        downloadPopup: _downloadPopup2.default,
        AppMatchTag: _AppMatchTag2.default
    },
    data: function data() {
        return {
            currentNavTag: 'COCOK',
            scroll: 0,
            is_jump: true,
            isOperamini: false,
            headerHeight: 0
        };
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getMatchSubTabList', 'getMatchLoading', 'getMatchNoDataMode', 'getMatchLoadingShow', 'getDownloadFooterShow', 'getCurrentMatchListData', 'getFinalListSplitDateData']), {
        subtitChoose: function subtitChoose() {
            return this.$store.state.navStore.subtitChoose;
        },
        lastEndMatch: function lastEndMatch() {
            var list = (0, _values2.default)(this.getFinalListSplitDateData).flatMap(function (item) {
                return item.filter(function (e) {
                    return e.status === 'Played';
                });
            });
            return list.length ? list[list.length - 1] : null;
        }
    }),

    asyncData: function asyncData(_ref) {
        var _this = this;

        var store = _ref.store,
            _ref$route$params = _ref.route.params,
            subtitle = _ref$route$params.subtitle,
            title = _ref$route$params.title;

        var allFetch = function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var menus, chooseArr, urlApi, matchList;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return store.dispatch('menusListApi', { subtitle: subtitle, type: 'COCOK' });

                            case 2:
                                menus = _context.sent;
                                chooseArr = store.getters.getMatchSubTabList.filter(function (ele) {
                                    return ele.label === store.state.navStore.subtitChoose;
                                });
                                urlApi = chooseArr && chooseArr.length && chooseArr[0].urlApi || '';
                                _context.next = 7;
                                return store.dispatch('matchListApi', { urlApi: urlApi });

                            case 7:
                                matchList = _context.sent;
                                return _context.abrupt('return', _promise2.default.all([menus, matchList]));

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function allFetch() {
                return _ref2.apply(this, arguments);
            };
        }();
        return allFetch();
    },
    mounted: function mounted() {
        var that = this;
        this.onScroll = function () {
            var utilObj = __webpack_require__(499);
            utilObj.lazyload('listwrap', 'teamlogo');
            that.stickyFn();
        };
        window.addEventListener('scroll', this.onScroll, false);
        var utilObj = __webpack_require__(499);
        utilObj.timeForInOut();
        this.isOperamini = utilObj.checkOperamini();

        this.headerHeight = document.querySelector('#topFixedWrap').offsetHeight;
        this.scrollToAnchor();
    },


    updated: function updated() {
        console.log('update:||||||||');
        var utilObj = __webpack_require__(499);
        utilObj.lazyload('listwrap', 'teamlogo');

        this.scrollToAnchor();
    },
    head: function head() {
        var referer = this.subtitChoose;
        return {
            title: referer + ' football matchs\uFF0CLive Scores\uFF0CMatch analysis | All Sepakbola',
            meta: [{
                name: 'description',
                content: 'The ' + referer + ' football match details, including live text commentary, team line-ups, match analysis, odds...'
            }, {
                name: 'keywords',
                content: 'football app, allfootballapp.com,  ' + referer + ' matchs, All Sepakbola, ' + referer + ' live scores, ' + referer + ' scores, '
            }]
        };
    },

    methods: {
        tran12: function tran12(time) {
            var time_arr = time.split(':');
            if (time_arr[0] > 12) {
                var result = time_arr[0] - 12 + ':' + time_arr[1] + ' FM';
            } else {
                var result = time_arr[0] + ':' + time_arr[1] + ' AM';
            }
            return result;
        },
        stickyFn: function stickyFn(ev) {
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                var topFixedWrap = document.getElementById('topFixedWrap');
                if (!topFixedWrap) {
                    return;
                }
                var topFixedWrapHeight = topFixedWrap.offsetHeight;
                this.scroll = document.body.scrollTop;

                var headHeight = 0;
                var contentWrap = document.getElementById('contentWrap');
                if (this.scroll >= headHeight) {
                    topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                    contentWrap.style.paddingTop = topFixedWrapHeight + 'px';
                } else {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }
            }
        },
        scrollToAnchor: function scrollToAnchor() {
            var _this2 = this;

            if (process.browser) {
                this.$nextTick(function () {
                    if (!_this2.lastEndMatch) return;

                    var anchor = document.querySelector('#match-' + _this2.lastEndMatch.match_id);

                    if (!anchor) return;

                    var scrollTop = anchor.offsetTop - _this2.headerHeight;

                    window.scrollTo({
                        top: scrollTop
                    });
                });
            }
        },
        handleJumpMatchDetailPage: function handleJumpMatchDetailPage(match) {
            var link = this.buildMatchDetailPageLink(match);
            var matchTag = match.live_icon || {};

            localStorage.setItem('match_tag', (0, _stringify2.default)(matchTag));
            window.location.href = link;
        },
        buildMatchDetailPageLink: function buildMatchDetailPageLink(match) {
            var teamAName = encodeURIComponent(match.team_A_name.replace(/\s/g, '-'));
            var teamBName = encodeURIComponent(match.team_B_name.replace(/\s/g, '-'));
            var matchId = match.match_id;

            return '/match/' + this.subtitChoose + '/' + teamAName + '-vs-' + teamBName + '/' + matchId;
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(741), __esModule: true };

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(32);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 742:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("\n        Untuk memberi Anda pengalaman yang lebih baik, silakan unduh aplikasi profesional kami.\n    ")]) : _vm._e(), _vm._v(" "), _c('navVue', {
    attrs: {
      "subtitleData": _vm.getMatchSubTabList,
      "navSelected": _vm.currentNavTag
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.getMatchNoDataMode && !_vm.getMatchLoadingShow) ? _c('nodata', {
    attrs: {
      "whiteMode": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getMatchLoadingShow) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.getMatchNoDataMode && !_vm.getMatchLoadingShow) ? _c('div', {
    staticClass: "listwrap",
    attrs: {
      "id": "listwrap"
    }
  }, [_vm._l((_vm.getFinalListSplitDateData), function(item, key, index) {
    return _c('div', {
      key: index
    }, [_c('p', {
      staticClass: "dateTit"
    }, [_c('span', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('em', [_vm._v(_vm._s(item.localdate))])]), _vm._v(" "), _vm._l((item), function(elem, index) {
      return _c('div', {
        key: index,
        staticClass: "sameDateData",
        attrs: {
          "id": ("match-" + (elem.match_id))
        }
      }, [_c('div', {
        staticClass: "list"
      }, [_c('div', {
        staticClass: "clearfix",
        on: {
          "click": function($event) {
            _vm.handleJumpMatchDetailPage(elem)
          }
        }
      }, [_c('dl', {
        staticClass: "flwrap"
      }, [_c('dt', [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamlogo",
        attrs: {
          "data-src": _vm.getImgSrc(elem.team_A_logo)
        }
      })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(elem.team_A_name))])]), _vm._v(" "), (elem.status === 'Fixture') ? _c('div', {
        staticClass: "unStart_competewrap competewrap"
      }, [_c('div', {
        staticClass: "unStartInfor"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                        " + _vm._s(_vm.tran12(elem.localdate.local_hms)) + "\n                                        " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                    ")]), _vm._v(" "), _c('p', {
        staticClass: "vs"
      }, [_vm._v("vs")]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1)]) : (elem.status === 'Postponed' || elem.status === 'Cancelled' || elem.status === 'Suspended') ? _c('div', {
        staticClass: "unStart_competewrap competewrap"
      }, [_c('div', {
        staticClass: "unStartInfor"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                        " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                        "), _c('span', {
        staticClass: "text-gray"
      }, [_vm._v(_vm._s(elem.status))])]), _vm._v(" "), _c('p', {
        staticClass: "vs"
      }, [_vm._v("vs")]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1)]) : (elem.status === 'Playing') ? _c('div', {
        staticClass: "statusPlaying_competewrap competewrap"
      }, [_c('div', {
        staticClass: "playingUnLive"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                        " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                        "), _c('span', {
        staticClass: "playingUnliveTime"
      }, [_vm._v(_vm._s(elem.playing_time) + "'")])]), _vm._v(" "), _c('p', {
        staticClass: "playingScore"
      }, [_c('span', [_vm._v(_vm._s(elem.fs_A))]), _c('em', {
        staticClass: "dot"
      }, [_vm._v(":")]), _c('span', [_vm._v(_vm._s(elem.fs_B))])]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1)]) : (elem.status === 'Played') ? _c('div', {
        staticClass: "statusEnd_competewrap competewrap"
      }, [_c('p', {
        staticClass: "competename"
      }, [_vm._v("\n                                    " + _vm._s(elem.competition_name) + " " + _vm._s(elem.gameweek) + "\n                                    "), _c('span', {
        staticClass: "status"
      }, [_vm._v("akhir")])]), _vm._v(" "), _c('p', {
        staticClass: "compete-center mb5"
      }, [_c('span', [_vm._v(_vm._s(elem.fs_A))]), _c('em', {
        staticClass: "line"
      }), _c('span', [_vm._v(_vm._s(elem.fs_B))])]), _vm._v(" "), (elem.live_icon) ? _c('AppMatchTag', {
        attrs: {
          "type": elem.live_icon.type
        }
      }) : _vm._e()], 1) : _c('div', {
        staticClass: "text-vs"
      }, [_vm._v("vs")]), _vm._v(" "), _c('dl', {
        staticClass: "frwrap"
      }, [_c('dt', [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamlogo",
        attrs: {
          "data-src": _vm.getImgSrc(elem.team_B_logo)
        }
      })]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(elem.team_B_name))])])])])])
    })], 2)
  }), _vm._v(" "), (_vm.getDownloadFooterShow) ? _c('DownloadFooter', {
    attrs: {
      "text": "Unduh All Sepakbola untuk lebih banyak pertandingan"
    }
  }) : _vm._e()], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.ab10f064f4bf9438178b.js